const ITEMS = [
  "Chapter Eighteen",
  "Venerdì 20 Novembre",
  "Casa Aurora · Cascina",
  "Brindiamo insieme",
  "Black & Chic",
];

function Sequence({ hidden }) {
  return (
    <div className="marquee-seq" aria-hidden={hidden || undefined}>
      {ITEMS.map((item) => (
        <span key={item} style={{ display: "contents" }}>
          <span className="mq-item">{item}</span>
          <span className="mq-dot" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="marquee" data-testid="marquee">
      <div className="marquee-track">
        <Sequence />
        <Sequence hidden />
      </div>
    </div>
  );
}
